export default __webpack_public_path__ + "static/media/ScratchJr.f1c1cc3d.png";